import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

// https://github.com/STRML/react-grid-layout/issues/528
const WidthProvider = ComposedComponent => {
    function WidthProviderWrapper({ measureBeforeMount = false, ...props }) {
        const [width, setWidth] = useState(1280);
        const [mounted, setMounted] = useState(false);
        const nodeRef = useRef(null);

        function calculateWidth() {
            if (nodeRef.current) {
                setWidth(nodeRef.current.offsetWidth);
            }
        }

        useEffect(() => {
            setMounted(true);
            const handleResize = () => { setTimeout(calculateWidth, 200); };
            window.addEventListener('resize', handleResize);
            handleResize();
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        if (measureBeforeMount && !mounted) {
            return <div ref={nodeRef} className={props.className} style={props.style} />;
        }

        return <div ref={nodeRef} style={{ width: '100%' }}><ComposedComponent {...props} width={width} /></div>;
    }

    WidthProviderWrapper.propTypes = { measureBeforeMount: PropTypes.bool };

    return WidthProviderWrapper;
};

export default WidthProvider
